<template>
  <filter-wrapper @submit="submit">
    <div class="filter__row">
      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('autocaller_v2.operators.field.login') }}
        </label>
        <div class="filter__item__body">
          <i-input v-model="form.search" :clearable="true" />
        </div>
      </div>
      <select-status v-model="form.active" class="col-3" />
      <select-wrtc v-model="form.wrtc" class="col-3" />
    </div>
    <div class="filter__row">
      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('autocaller_v2.operators.field.instance') }}
        </label>
        <div class="filter__item__body">
          <select-region-instanse v-model="form.instance_id" :clearable="true" />
        </div>
      </div>
      <div class="filter__item col-3">
        <label>{{ $t('autocaller_v2.operators.field.created_at') }}</label>
        <z-form-input>
          <date-picker v-model="form.start" type="datetime" class="w-100" />
        </z-form-input>
      </div>
      <div class="filter__item filter__item--button">
        <i-button html-type="submit" type="primary">
          {{ $t('shared.component.filter.show_result') }}
        </i-button>
      </div>
    </div>
  </filter-wrapper>
</template>

<script>
  import SelectStatus from './campaigns-filter-status';
  import SelectWrtc from './operators-filter-wrtc';
  import SelectRegionInstanse from './campaigns-input-region-instance';
  import FilterWrapper from '@shared/components/filter-base';
  import { toBackendDateWithTime } from '@shared/helpers/date_format';
  import { mapActions } from 'vuex';

  export default {
    components: {
      FilterWrapper,
      SelectStatus,
      SelectWrtc,
      SelectRegionInstanse
    },
    data: () => ({
      numbers: [],
      form: {
        search: '',
        caller_id: '',
        instance_id: '',
        wrtc: '',
        active: '',
        start: '',
        weight: '',
        type: ''
      }
    }),
    computed: {
      is_pbx_allow: function () {
        return this.$permission.module_pbx_is_allowed;
      }
    },

    created() {
      this.submit();
    },

    methods: {
      ...mapActions('autocaller_v2/operators/table', ['search']),
      submit: function () {
        const { search = '', active, type, callers, wrtc, instance_id } = this.form;
        const start = this.form.start ? toBackendDateWithTime(this.form.start) : '';
        const params = {
          login: search,
          wrtc,
          instance_id,
          start,
          active,
          type,
          callers
        };
        for (let key in params) {
          params[key] === '' ? delete params[key] : params[key];
        }
        this.search(params);
      }
    }
  };
</script>
